export interface PoiConfig {
  /** When enabled, POI markers are only visible if their sight is not occluded */
  showVisibleOnly: boolean;
  /** How far (in world units) the occlusion probe may step toward the camera to avoid self-intersection */
  occlusionProbeMaxOffset: number;
  /** Minimum distance (in world units) to keep between the probe point and the POI center */
  occlusionProbeMinDistance: number;
  /** Enable overlap-based clustering of markers whose bounding boxes intersect on screen */
  clusterEnabled: boolean;
  /** Extra padding (px) for hysteresis — existing clusters need this gap to split apart */
  clusterUnmergePadding: number;
}

export const defaultPoiConfig: PoiConfig = {
  showVisibleOnly: false,
  occlusionProbeMaxOffset: 0,
  occlusionProbeMinDistance: 0.02,
  clusterEnabled: true,
  clusterUnmergePadding: 8,
};
